import React from 'react';
import { useRecoilState } from 'recoil';

import RightSidePanel from '@/components/common/RightSidePanel/RightSidePanel';
import { rightsidePanel_isOpen } from './RightPanel.state';
import { rightPanelTabs } from './tabs';

export default function RightPanelContainer() {
  const [isOpen, setIsOpen] = useRecoilState(rightsidePanel_isOpen);
  return (
    <RightSidePanel
      tabs={rightPanelTabs}
      isOpen={isOpen}
      onCollapse={setIsOpen}
    />
  );
}
